export default __webpack_public_path__ + "static/media/deckOfFiles.bd5efe4a.jpg";